import styled from 'styled-components';
import tw from 'twin.macro';
import { Modal } from '../modal';
import { Button } from '../button';
import { getBrand } from '../../constants/brands';

export const BOOKINGS_CLOSED_TITLE = 'Bookings open soon';

/** Used only when the server sent no text (an older API answering the refusal). */
export function bookingsClosedFallback(brandName: string): string {
  return `${brandName} isn't taking bookings yet. Your card was not charged. Please check back soon.`;
}

const Title = styled.h2`
  ${tw`text-xl font-semibold m-0`}
  color: var(--color-text-primary);
`;

const Body = styled.p`
  ${tw`text-sm mt-2 mb-5`}
  color: var(--color-text-secondary);
`;

/**
 * Spec 023: what a guest sees after pressing Pay on a site that is not taking bookings
 * yet. The text comes from the server (`bookingsClosedMessage` or the refusal's message).
 */
export function BookingsClosedModal({
  message,
  onClose,
}: {
  /** Null keeps it closed. */
  message: string | null;
  onClose: () => void;
}) {
  return (
    <Modal
      isOpen={message !== null}
      onClose={onClose}
      title={BOOKINGS_CLOSED_TITLE}
      contentAlign="center"
      modalWidth="min(420px, calc(100vw - 2rem))"
    >
      <div data-testid="bookings-closed-modal">
        <Title>{BOOKINGS_CLOSED_TITLE}</Title>
        <Body>{message || bookingsClosedFallback(getBrand().name)}</Body>
        <Button
          text="OK"
          type="button"
          onClick={onClose}
          fullWidth
          dataTestId="bookings-closed-ok"
        />
      </div>
    </Modal>
  );
}
